import React from 'react';

const TrustedBy = () => {
  return (
    <section className="container px-8 py-16 mx-auto">
      <div className="flex flex-col items-center justify-between gap-12 md:flex-row">
        {/* Left Content */}
        <div className="w-full space-y-6 md:w-1/2">
          <div className="space-y-4">
            <h2 className="text-5xl font-bold text-gray-900">
              Trusted by <span className="text-orange-500">80K+</span>
            </h2>
            <h2 className="text-5xl font-bold text-gray-900">
              Dental
            </h2>
            <h2 className="text-5xl font-bold text-gray-900">
              Professionals
            </h2>
            <p className="text-2xl text-gray-700">At Practices of All Sizes</p>
          </div>

          <div className="flex gap-8 mt-8">
            <div className="border-b-4 border-orange-500">
              <span className="text-xl font-medium">StartUps</span>
            </div>
            <div className="text-xl text-gray-600">
              Single Location
            </div>
            <div className="text-xl text-gray-600">
              Multi-Location
            </div>
          </div>

          <p className="text-lg leading-relaxed text-gray-700">
          Start and grow a thriving dental practice with the right tools. EzzyDental's all-in-one cloud-based platform streamlines operations, enhances patient experience, and boosts profitability. Maximize your ROI from day one with advanced scheduling, automated billing, and AI-driven patient engagement. See real success stories from dental practices like yours that have transformed with EzzyDental.
          </p>

          <button className="px-8 py-3 text-lg text-white transition-colors bg-orange-500 rounded-full hover:bg-orange-600">
            Learn More
          </button>

          {/* Stats Section */}
          <div className="bg-[#1E2A4A] text-white p-8 rounded-xl mt-12 grid grid-cols-3 gap-8">
            <div className="text-center">
              <div className="text-4xl font-bold">$25K</div>
              <div className="mt-2 text-sm">saved on upfront server costs</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold">$700</div>
              <div className="mt-2 text-sm">monthly savings on IT costs</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold">30</div>
              <div className="mt-2 text-sm">days to get up-and-running</div>
            </div>
          </div>

          {/* Customer Success Stories */}
          <div className="mt-8">
            <h3 className="mb-4 text-xl font-semibold">Customer Success Stories</h3>
            <div className="grid grid-cols-3 gap-4">
              {[1, 2, 3].map((index) => (
                <div key={index} className="overflow-hidden bg-white rounded-lg shadow-lg">
                  <div className="relative pb-[56.25%]">
                    <img 
                      src={`/assets/customer-${index}.webp`} 
                      alt={`Customer Success Story ${index}`}
                      className="absolute inset-0 object-cover w-full h-full"
                    />
                    <button className="absolute inset-0 flex items-center justify-center">
                      <div className="flex items-center justify-center w-12 h-12 bg-orange-500 rounded-full">
                        <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6 text-white" viewBox="0 0 20 20" fill="currentColor">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z" clipRule="evenodd" />
                        </svg>
                      </div>
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Right Image */}
        <div className="w-full md:w-1/2">
          <img 
            src="/assets/Trusted Dental Professionals.webp" 
            alt="Trusted Dental Professionals" 
            className="w-full shadow-lg rounded-2xl"
          />
        </div>
      </div>
    </section>
  );
};

export default TrustedBy;
